var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row flex-wrap"},_vm._l((_vm.getAnswerers()),function(answerer){return _c('span',{key:answerer.nick_name},[_c('PlayerName',{attrs:{"answerer":answerer,"highlight":_vm.highlight(answerer)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }